import { authHeader } from "../_helpers";
import { ServiceUtil } from "./services.util";
import { ProfileApi } from "./profile.service";
import { newLoanService } from "./newloan.service.js"

const LANGUAGES = {
    EN : "EN",
    ES : "ES"
}

export const userService = {
    CLAIM_USER_EMAIL: "email",
    CLAIM_USER_NAME: "name",
    CLAIM_USER_MOBILE: "phone_number",
    CLAIM_USER_ID: "sub",
    CLAIM_USER_ZIP_CODE: "sl:zip",
    CLAIM_USER_LANGUAGE: "sl:lang",
    CLAIM_DEVICE_ID: "sl:deviceid",
    CLAIM_BANKRUPTCY_FLAG: "sl:bankruptcy",
    CLAIM_SUSPENDED_FLAG: "sl:suspendedFlag",
    CLAIM_ISSUED_AT: "iat",
    CLAIM_EXPIRES: "exp",
    SCOPE_USER_WRITE: "client.write",
    SCOPE_USER_READ: "client.read",
    SCOPE_MAKE_PAYMENT: "client.makePayment",
    ACTION_LOGIN: "login",
    ACTION_AUTH_DEVICE: "auth.device",
    ACTION_AUTH_DEVICE_CODE: "auth.device.code",
    ACTION_SHOW_EMAIL_IN_USE: "ACTION_SHOW_EMAIL_IN_USE",
    ACTION_SHOW_RECAPTCHA_FAILED: "ACTION_SHOW_RECAPTCHA_FAILED",
    ACTION_USER_HASH_IN_USE: "ACTION_USER_HASH_IN_USE",
    TRUE: "True",
    FALSE: "False",
    LANGUAGES,
    login,
    logout,
    register,
    getById,
    isEmailInUse,
    isHashInUse,
    update,
    getCurrentUser,
    setCurrentUser,
    getUserClaim,
    getTokenPayload,
    userHasScope,
    getUserLanguage,
    setUserLanguage,
    renewToken,
    shouldRenewToken,
    getTokenExpiration,
    userHasProblemFlags,
    loginFromRegistration,
    saveLPXRelatedItems,
    isInstantFundingEnabled,
    isMyDocumentsEnabled,
    isSMSForDocumentsEnabled,
    fetchOnlineDisclosures
};

function getUserClaim(claim) {
    const token = getTokenPayload();
    if (token) {
        return token[claim];
    }
    return null;
}

async function renewToken(force) {
    if (sessionStorage.getItem("renewTokenLock")) {
        return;
    }
    if (shouldRenewToken() || force) {
        sessionStorage.setItem("renewTokenLock", true);
        ServiceUtil.executeServiceCall(
            "AccountAPI",
            "Account/RenewToken",
            ServiceUtil.getRequest()
        ).then((result) => {
            if (result.status <= 1) {
                let user = getCurrentUser();
                if (user) {
                    user.tokenString = result.data;
                    setCurrentUser(user);
                }
            } else {
                //token renew failed.
            }
            sessionStorage.removeItem("renewTokenLock");
        });
    }
}

//Returns a true if the Suspended Flag or the bankruptcy flag is set to true
function userHasProblemFlags() {
    if (getCurrentUser()) {
        const suspendedFlag = getUserClaim(this.CLAIM_SUSPENDED_FLAG);
        const bankruptcyFlag = getUserClaim(this.CLAIM_BANKRUPTCY_FLAG);

        if (suspendedFlag === this.TRUE || bankruptcyFlag == this.TRUE) {
            return true;
        }
    }
    return false;
}

function shouldRenewToken() {
    if (getCurrentUser()) {
        const issuedAt = getUserClaim("iat");
        const expires = getUserClaim("exp");
        if (expires && issuedAt) {
            const midPoint = issuedAt + (expires - issuedAt) / 2;
            return Date.now() > midPoint * 1000;
        }
    }
    return false;
}

function getTokenExpiration() {
    const expires = getUserClaim("exp");
    if (expires) {
        return expires * 1000 - Date.now();
    }
    return null;
}

function userHasScope(scope) {
    const scopesClaim = getUserClaim("scp");
    if (scopesClaim) {
        //split the scopes
        const scopes = scopesClaim.split(" ");
        return scopes.includes(scope);
    }
    return false;
}

async function isEmailInUse(email) {
    const isEmailInUse = await ServiceUtil.executeServiceCall(
        "AccountAPI",
        "Account/IsEmailInUse",
        ServiceUtil.postRequest(email)
    );
    return isEmailInUse;
}

async function isHashInUse(userHash) {
    const isHashInUse = await ServiceUtil.executeServiceCall(
        "ProfileAPI",
        "api/Profile/IsHashInUse",
        ServiceUtil.postRequest(userHash)
    );
    return isHashInUse;
}

async function login(username, password, mfaRequest) {
    let email = username.trim();
    let authRequest = {
        email,
        password,
        deviceRegistration: {
            deviceType: 0,
            deviceInfo: navigator.userAgent,
            deviceId: ServiceUtil.getDeviceId()
        },
        mfaAuthRequest: mfaRequest
    };
    const user = await ServiceUtil.executeServiceCall(
        "AccountAPI",
        "Account/LoginFromClient",
        ServiceUtil.postRequest(authRequest)
    );

    if (user.status <= 1 && user.data.messageId >= 0) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        sessionStorage.setItem("user", JSON.stringify(user));
    }
    return user;
}
async function loginFromRegistration(username, password, mfaRequest, deviceRegistration = null) {
    let email = username.trim();
    let authRequest = {
        email,
        password,
        deviceRegistration: deviceRegistration ? deviceRegistration : {
            deviceType: 0,
            deviceInfo: navigator.userAgent,
            deviceId: ServiceUtil.getDeviceId()
        },
        mfaAuthRequest: mfaRequest
    };
    const user = await ServiceUtil.executeServiceCall(
        "AccountAPI",
        "Account/LoginFromRegistration",
        ServiceUtil.postRequest(authRequest)
    );

    if (user.status <= 1 && user.data.messageId >= 0) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        //sessionStorage.setItem("user", JSON.stringify(user));
    }
    return user;
}

function getCurrentUser() {
    const userJson = sessionStorage.getItem("user");
    if (userJson) {
        return JSON.parse(userJson);
    }
    return null;
}

function setCurrentUser(user) {
    sessionStorage.setItem("user", JSON.stringify(user));
}

function getUserLanguage() {
    if (sessionStorage.getItem("lang")) {
        return sessionStorage.getItem("lang");
    } else if (getUserClaim(userService.CLAIM_USER_LANGUAGE)) {
        return getUserClaim(userService.CLAIM_USER_LANGUAGE);
    } else {
        let lang = navigator.languages
            ? navigator.languages[0]
            : navigator.language || navigator.userLanguage;
        return lang.substr(0, 2);
    }
}
function setUserLanguage(lang) {
    sessionStorage.setItem("lang", lang === LANGUAGES.ES ? lang : LANGUAGES.EN);
    document.dispatchEvent(new Event('language'));
}

function logout() {
    // remove user from local storage to log user out

    if (getCurrentUser()) {
        ServiceUtil.executeServiceCall(
            "AccountAPI",
            "Account/Logout",
            ServiceUtil.getRequest()
        );
    }
    sessionStorage.removeItem("user");
    let tmpLang = sessionStorage.getItem("lang");
    sessionStorage.clear();
    if (tmpLang != null) {
        sessionStorage.setItem("lang", tmpLang);
    }
}

function getById(id) {
    const requestOptions = {
        method: "GET",
        headers: authHeader(),
    };

    return fetch(`users/${id}`, requestOptions).then(ServiceUtil.handleResponse);
}

function register(user) {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(user)
    };

    return fetch(`/users/register`, requestOptions).then(
        ServiceUtil.handleResponse
    );
}

function getTokenPayload() {
    const user = getCurrentUser();

    if (user && user.tokenString) {
        const token = user.tokenString;
        //Decode the token.

        var base64Url = token.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map(function (c) {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
        );

        return JSON.parse(jsonPayload);
    }
    return null;
}
function update(user) {
    const requestOptions = {
        method: "PUT",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(user)
    };

    return fetch(`/users/${user.id}`, requestOptions).then(
        ServiceUtil.handleResponse
    );
}

async function isInstantFundingEnabled(state = null) {

    if (getCurrentUser()) {
        return await ProfileApi.getExtendedProfileInfo()
            .then(async result => {
                if (result.status <= 1) {
                    return await ServiceUtil.isInstantFundingEnabled(result.data.state)
                        .then(async result => {
                            return result;
                        });
                }
                return false;
            });
    } else if (state) {
        return await ServiceUtil.isInstantFundingEnabled(state)
            .then(async result => {
                return result;
            });
    }

    return false;
}

async function isMyDocumentsEnabled() {
    if (getCurrentUser()) {
        return await ProfileApi.getExtendedProfileInfo()
            .then(async result => {
                if (result.status <= 1) {
                    return await ServiceUtil.isMyDocumentsEnabled(result.data.state)
                        .then(async res => {
                            return res;
                        });
                }
                return false;
            }
            );
    }
    return false;
}

async function isSMSForDocumentsEnabled() {
    return await ServiceUtil.isSMSForDocumentsEnabled()
        .then(async res => {
            return res;
        })
}

async function fetchOnlineDisclosures() {
    return await newLoanService.getOnlineDisclosures();
}

//forces save of LPX items - usually used if a person is not logged in
async function saveLPXRelatedItems(state) {
    //    ServiceUtil.isLPXState(state)
    //        .then(lpxResult => {
    //            sessionStorage.setItem("isLPX", lpxResult);
    //        });
    //
    //    ServiceUtil.isInstantFundingEnabled(state)
    //        .then(lpxResult => {
    //            sessionStorage.setItem("isInstantFundingEnabled", lpxResult);
    //        });
    //
    //    ServiceUtil.isMyDocumentsEnabled(state)
    //        .then(lpxResult => {
    //            sessionStorage.setItem("isMyDocumentsEnabled", lpxResult);
    //        });
}




// WEBPACK FOOTER //
// ./src/_services/user.service.js